module.exports = __webpack_public_path__ + "img/1f62d.05ff1af.svg";